export const MP3_CODEC = "mp3";
export const BITRATE_64_KBPS = "64kbps";
export const FORMAT_64K_MP3 = "64kmp3";
export const FORMAT_64K_WMA = "64kwma";
